import { useLocation } from 'react-router';

export const useWidgetHashTarget = (widgetId: string | undefined): boolean => {
  const location = useLocation();
  return Boolean(widgetId) && location.hash === `#widget-${widgetId}`;
};
